'use client';
import React from 'react';
import Link from 'next/link';
import { Activity, ArrowRight } from 'lucide-react';

export default function DashboardWelcome() {
  const dateStr = new Date().toLocaleDateString('en-CA', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });

  return (
    <div className="bg-gradient-to-r from-[#1a4089] to-[#204998] rounded-3xl p-6 sm:p-8 text-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-4 right-8 w-48 h-48 rounded-full border-4 border-white" />
        <div className="absolute top-16 right-24 w-28 h-28 rounded-full border-2 border-white" />
        <div className="absolute -bottom-8 -left-8 w-40 h-40 rounded-full border-2 border-white" />
      </div>

      <div className="relative z-10 flex flex-col gap-5">
        <div>
          <p className="text-blue-200 text-sm font-medium mb-1">{dateStr}</p>
          <h1 className="text-2xl sm:text-3xl xl:text-4xl font-bold text-white mb-2 sm:mb-3">
            How are you feeling today?
          </h1>
          <p className="text-blue-200 text-sm sm:text-base max-w-xl leading-relaxed">
            Complete a health assessment to get a personalized care recommendation based on your symptoms. Results in under 3 minutes.
          </p>
        </div>

        <Link
          href="/assessment-personal-information-confirmation"
          className="inline-flex items-center justify-center gap-3 bg-[#7ebc59] hover:bg-[#5a9a38] text-white font-bold text-base px-8 py-4 rounded-full transition-all duration-150 active:scale-95 shadow-lg self-start w-full sm:w-auto"
        >
          <Activity size={20} />
          Start Health Assessment
          <ArrowRight size={18} />
        </Link>
      </div>
    </div>
  );
}
